import { Suspense, useEffect } from "react";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Index from "./pages/Index";
import GrunderloftetFrame from "@/components/GrunderloftetFrame";


const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const Personvern = lazy(() => import("./pages/Personvern"));
const Vilkar = lazy(() => import("./pages/Vilkar"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Prosess = lazy(() => import("./pages/Prosess"));
const Priser = lazy(() => import("./pages/Priser"));
const Kundecase = lazy(() => import("./pages/Kundecase"));
const OmOss = lazy(() => import("./pages/OmOss"));
const HjemmesideForSmaBedrifter = lazy(() => import("./pages/HjemmesideForSmaBedrifter"));
const Grunderloftet = lazy(() => import("./pages/Grunderloftet"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/tjenester" element={<Navigate to="/#tjenester" replace />} />
            <Route path="/tjenester/:serviceId" element={<ServiceDetail />} />
            <Route path="/prosess" element={<Prosess />} />
            <Route path="/priser" element={<Priser />} />
            <Route path="/kundecase" element={<Kundecase />} />
            <Route path="/om-oss" element={<OmOss />} />
            <Route path="/hjemmeside-for-sma-bedrifter" element={<HjemmesideForSmaBedrifter />} />
            <Route path="/grunderloftet" element={<Grunderloftet />} />
            <Route path="/personvern" element={<Personvern />} />
            <Route path="/vilkar" element={<Vilkar />} />
            <Route path="/faq" element={<FAQ />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <GrunderloftetFrame />
      </BrowserRouter>

    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
